import styled, { css } from 'styled-components';
import statusMapIcon_gas_blue from 'static/images/icon/statusMapIcon_gas_blue.png';
import statusMapIcon_gas_warning from 'static/images/icon/statusMapIcon_gas_warning.png';
import statusMapIcon_gas_danger from 'static/images/icon/statusMapIcon_gas_danger.png';
import statusMapIcon_gas_none from 'static/images/icon/statusMapIcon_gas_none.png';

export const StatusMapContainer = styled.div`
  position: relative;
  text-align: center;
  display: inline-block;

  & img {
    height: 900px;
  }
`;

export const ArrangementStatusContainer = styled.div`
  position: absolute;
  left: 1200px;
  top: 31px;
  background: ${(props) => props.theme.legendBg};
  width: 315px;
  color: #000;

  & > div.statusBox {
    display: flex;
    flex-direction: row;
    text-align: center;

    & > div.title {
      border-right: 1px solid #000;
      padding: 0 5px;
    }
    & > div.content {
      padding: 0 5px;
    }
  }

  & > table,
  tr,
  th,
  td {
    border: 1px solid #000;
  }

  & > table {
    width: 100%;

    & > thead > tr > th {
      font-size: 12px;
    }
    & > tbody > tr > td {
      font-size: 14px;

      & > img {
        width: 40px;
      }
    }
  }
`;

export const SideMapContainer = styled.div`
  position: relative;
  width: 350px;
  height: 900px;

  & > div.arrangementStatus {
    position: absolute;
    left: 0px;
    top: 0px;
  }

  & > div.title {
    margin: 0;
    padding: 0.5rem;
    background: #5b2f2f;
    border-radius: 6px;
    color: #fff;
    font-size: 30px;
    display: flex;
    justify-content: center;
    align-items: center;

    & > span {
      line-height: 0.5;
      cursor: pointer;
    }
  }

  & > div.content {
    text-align: left;
    margin: 0;
    padding: 0.5rem;
    border-bottom: 0.5px #1f242c solid;
    color: #fff;
    cursor: pointer;
  }
`;

export const AreaBox = styled.div`
  position: relative;

  .areaName {
    position: absolute;
    color: #fff;
    top: 40px;
    left: -75px;
    width: 200px;

    p {
      background: #4c4c4c;
      width: fit-content;
      margin: auto;
      padding: 0 10px;
      font-size: 12px;
    }
  }
`;
